const paginatedCollections = (data) => ({
  isLastPage: false,
  page: 0,
  cardsPerPage: null,
  totalPages: null,

  get cards() {
    return this.$root.querySelectorAll('.paginated-collections__card');
  },

  loadNextPage() {
    const start = this.page * this.cardsPerPage;
    const end = start + this.cardsPerPage;

    [...this.cards]
      .slice(start, end)
      .forEach((card) => card.classList.remove('is-hidden'));

    this.page += 1;

    if (this.page === this.totalPages) {
      this.isLastPage = true;
    }
  },

  setData() {
    if (window.innerWidth < 768) {
      this.cardsPerPage = data.cardsPerPageMobile || 6;
    } else {
      this.cardsPerPage = data.cardsPerPageDesktop || 8;
    }

    this.totalPages = Math.ceil(this.cards.length / this.cardsPerPage);
  },

  init() {
    this.setData();
    this.loadNextPage();
  },
});

export default paginatedCollections;
